import React from 'react';
import { DashboardHeaderProps } from './dashboard.types';
import styles from './Dashboard.module.css';
import AccountMenu from '../AccountMenu';
import { ChatBubbleLeftEllipsisIcon, HomeIcon, PaperAirplaneIcon, Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

/**
 * Dashboard Header Component
 * 
 * Top header bar for the dashboard containing the page title and account info.
 * Fixed to the top of the main content area.
 */

const menuItems = [
    {
        label: "Home",
        icon: <HomeIcon width={20} height={20} />,
        to: "/",
      },
      {
        label: "Chat",
        icon: <ChatBubbleLeftEllipsisIcon width={20} height={20} />,
        to: "/chat",
      },
      {
        label: "Contact us",
        icon: <PaperAirplaneIcon width={20} height={20} />,
        to: "/contact-us",
      },
];

interface ExtendedDashboardHeaderProps extends DashboardHeaderProps {
  isMobileSidebarVisible?: boolean;
  onMobileSidebarToggle?: () => void;
}

const DashboardHeader = ({ isMobileSidebarVisible = false, onMobileSidebarToggle }: ExtendedDashboardHeaderProps) => {
    return (
        <header className={styles.dashboardHeader}>
            <div className={styles.headerTitleContainer}>
                {/* Mobile sidebar toggle button */}
                <button 
                    className={styles.mobileSidebarToggle}
                    onClick={onMobileSidebarToggle}
                    aria-label={isMobileSidebarVisible ? "Close sidebar" : "Open sidebar"}
                >
                    {isMobileSidebarVisible ? (
                        <XMarkIcon width={24} height={24} />
                    ) : (
                        <Bars3Icon width={24} height={24} />
                    )}
                </button>
                <h1 className={styles.pageTitle}>Dashboard</h1>
            </div>
            <div className={styles.accountInfo}>
                <AccountMenu menuItems={menuItems} />
            </div>
        </header>
    );
};

export default DashboardHeader;
